@if (isNotifyMeShow) {
<div class="notify-me-container">
  <!-- SLIDE TOGGLE -->
  <mat-slide-toggle
    [checked]="isNotifyMeChecked"
    (change)="onChangeNotifyMeToggle($event)"
    class="notify-me-toggle"
  ></mat-slide-toggle>
  <span
    [ngClass]="{ 'toggle-label': !isModal, 'toggle-label-modal': isModal }"
    [innerHTML]="'stockNotification.notifyMe' | cxTranslate"
  ></span>
</div>
}
